export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* 品牌与简介 */}
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 font-heading text-sm font-black text-background-50">
                51
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">吃料</span>
            </a>
            <p className="mt-3 max-w-xs text-sm leading-6 text-foreground-600">
              今日汇总、热门合集、精选打包、完整列表，一处收齐。吃料只看这一处。
            </p>
          </div>

          {/* 栏目导航 */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-semibold text-foreground-950">栏目速达</h4>
            <div className="grid grid-cols-2 gap-2">
              {[
                { href: '#today', label: '今日汇总' },
                { href: '#hot', label: '热门合集' },
                { href: '#packs', label: '精选打包' },
                { href: '#comments', label: '热评现场' },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          {/* 一句说明 */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-semibold text-foreground-950">说在最后</h4>
            <p className="text-sm leading-6 text-foreground-600">
              这里更像是一张“去哪吃”的入口地图：内容均按公开信息整理归类，仅为个人浏览聚合，不作任何转载或商用主张。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 51吃料 · 吃料就看这一处
          </p>
          <p className="text-xs text-foreground-500">每日 21:00 更新 · 收藏本站，随时开吃</p>
        </div>
      </div>
    </footer>
  );
}